export const SEO_LANGUAGES = [
  "en",
  "ru",
  "de",
  "uk",
  "es",
  "pt",
  "fr",
  "it",
  "pl",
  "tr",
  "id",
  "hi",
  "ko",
  "ja",
  "zh",
  "ar",
];

export const DEFAULT_SEO_IMAGE = "https://mapapet.com/logo512.png";
export const SITE_NAME = "Mapapet";
export const SITE_ORIGIN = "https://mapapet.com";

export const LANGUAGE_DOMAINS = {
  en: "mapapet.com",
  ru: "ru.mapapet.com",
  de: "de.mapapet.com",
  uk: "uk.mapapet.com",
  es: "es.mapapet.com",
  pt: "pt.mapapet.com",
  fr: "fr.mapapet.com",
  it: "it.mapapet.com",
  pl: "pl.mapapet.com",
  tr: "tr.mapapet.com",
  id: "id.mapapet.com",
  hi: "hi.mapapet.com",
  ko: "ko.mapapet.com",
  ja: "ja.mapapet.com",
  zh: "zh.mapapet.com",
  ar: "ar.mapapet.com",
};

export const LANGUAGE_LOCALES = {
  en: "en_US",
  ru: "ru_RU",
  de: "de_DE",
  uk: "uk_UA",
  es: "es_ES",
  pt: "pt_PT",
  fr: "fr_FR",
  it: "it_IT",
  pl: "pl_PL",
  tr: "tr_TR",
  id: "id_ID",
  hi: "hi_IN",
  ko: "ko_KR",
  ja: "ja_JP",
  zh: "zh_CN",
  ar: "ar_SA",
};

const SEO_COPY = {
  en: {
    categoryDescription: (label) =>
      `Find ${label} listings, services and contacts near you on Mapapet's interactive map.`,
    blogDescription:
      "Practical guides about pets, animal care, farms, veterinary services and responsible ownership.",
    forumDescription:
      "An international animal community forum where people share experience, ask questions and help each other.",
    forumSectionTitle: (label) => `${label} forum | Mapapet`,
    notFoundTitle: "Page not found | Mapapet",
  },
  ru: {
    categoryDescription: (label) =>
      `Находите объявления, услуги и контакты по теме «${label}» рядом с вами на интерактивной карте Mapapet.`,
    blogDescription:
      "Практические статьи о животных, уходе, ферме, ветеринарии и ответственном содержании питомцев.",
    forumDescription:
      "Международный форум о животных, где пользователи делятся опытом, задают вопросы и помогают друг другу.",
    forumSectionTitle: (label) => `${label} — форум | Mapapet`,
    notFoundTitle: "Страница не найдена | Mapapet",
  },
  de: {
    categoryDescription: (label) =>
      `Finde Anzeigen, Dienstleistungen und Kontakte zu „${label}“ in deiner Nähe auf der interaktiven Mapapet-Karte.`,
    blogDescription:
      "Praktische Ratgeber zu Haustieren, Tierpflege, Landwirtschaft, Tiermedizin und verantwortungsvoller Haltung.",
    forumDescription:
      "Ein internationales Tierforum, in dem Menschen Erfahrungen teilen, Fragen stellen und einander helfen.",
    forumSectionTitle: (label) => `${label} Forum | Mapapet`,
    notFoundTitle: "Seite nicht gefunden | Mapapet",
  },
  uk: {
    categoryDescription: (label) =>
      `Знаходьте оголошення, послуги та контакти за темою «${label}» поруч із вами на інтерактивній карті Mapapet.`,
    blogDescription:
      "Практичні статті про тварин, догляд, фермерство, ветеринарію та відповідальне утримання улюбленців.",
    forumDescription:
      "Міжнародний форум про тварин, де користувачі діляться досвідом, ставлять запитання та допомагають одне одному.",
    forumSectionTitle: (label) => `${label} — форум | Mapapet`,
    notFoundTitle: "Сторінку не знайдено | Mapapet",
  },
  es: {
    categoryDescription: (label) =>
      `Encuentra anuncios, servicios y contactos de «${label}» cerca de ti en el mapa interactivo de Mapapet.`,
    blogDescription:
      "Guías prácticas sobre mascotas, cuidado animal, granjas, veterinaria y tenencia responsable.",
    forumDescription:
      "Un foro internacional sobre animales donde las personas comparten experiencias, hacen preguntas y se ayudan.",
    forumSectionTitle: (label) => `Foro de ${label} | Mapapet`,
    notFoundTitle: "Página no encontrada | Mapapet",
  },
  pt: {
    categoryDescription: (label) =>
      `Encontre anúncios, serviços e contactos de «${label}» perto de si no mapa interativo da Mapapet.`,
    blogDescription:
      "Guias práticos sobre animais, cuidados, quintas, veterinária e posse responsável.",
    forumDescription:
      "Um fórum internacional sobre animais onde as pessoas partilham experiências, fazem perguntas e se ajudam.",
    forumSectionTitle: (label) => `Fórum de ${label} | Mapapet`,
    notFoundTitle: "Página não encontrada | Mapapet",
  },
  fr: {
    categoryDescription: (label) =>
      `Trouvez des annonces, services et contacts pour «${label}» près de chez vous sur la carte interactive Mapapet.`,
    blogDescription:
      "Guides pratiques sur les animaux, les soins, les fermes, la médecine vétérinaire et la détention responsable.",
    forumDescription:
      "Un forum international sur les animaux où chacun partage son expérience, pose des questions et s'entraide.",
    forumSectionTitle: (label) => `Forum ${label} | Mapapet`,
    notFoundTitle: "Page introuvable | Mapapet",
  },
  it: {
    categoryDescription: (label) =>
      `Trova annunci, servizi e contatti per «${label}» vicino a te sulla mappa interattiva di Mapapet.`,
    blogDescription:
      "Guide pratiche su animali, cura, allevamento, veterinaria e gestione responsabile.",
    forumDescription:
      "Un forum internazionale sugli animali dove le persone condividono esperienze, fanno domande e si aiutano.",
    forumSectionTitle: (label) => `Forum ${label} | Mapapet`,
    notFoundTitle: "Pagina non trovata | Mapapet",
  },
  pl: {
    categoryDescription: (label) =>
      `Znajdź ogłoszenia, usługi i kontakty dotyczące „${label}” w pobliżu na interaktywnej mapie Mapapet.`,
    blogDescription:
      "Praktyczne poradniki o zwierzętach, opiece, gospodarstwie, weterynarii i odpowiedzialnym utrzymaniu.",
    forumDescription:
      "Międzynarodowe forum o zwierzętach, gdzie użytkownicy dzielą się doświadczeniem, pytają i pomagają sobie nawzajem.",
    forumSectionTitle: (label) => `Forum: ${label} | Mapapet`,
    notFoundTitle: "Nie znaleziono strony | Mapapet",
  },
  tr: {
    categoryDescription: (label) =>
      `Mapapet'in etkileşimli haritasında yakınınızdaki “${label}” ilanlarını, hizmetlerini ve iletişim bilgilerini bulun.`,
    blogDescription:
      "Evcil hayvanlar, bakım, çiftlik, veterinerlik ve sorumlu hayvan sahipliği hakkında pratik rehberler.",
    forumDescription:
      "İnsanların deneyim paylaştığı, soru sorduğu ve birbirine yardım ettiği uluslararası hayvan forumu.",
    forumSectionTitle: (label) => `${label} forumu | Mapapet`,
    notFoundTitle: "Sayfa bulunamadı | Mapapet",
  },
  id: {
    categoryDescription: (label) =>
      `Temukan iklan, layanan, dan kontak tentang “${label}” di sekitar Anda melalui peta interaktif Mapapet.`,
    blogDescription:
      "Panduan praktis tentang hewan, perawatan, peternakan, layanan dokter hewan, dan kepemilikan yang bertanggung jawab.",
    forumDescription:
      "Forum hewan internasional tempat orang berbagi pengalaman, bertanya, dan saling membantu.",
    forumSectionTitle: (label) => `Forum ${label} | Mapapet`,
    notFoundTitle: "Halaman tidak ditemukan | Mapapet",
  },
  hi: {
    categoryDescription: (label) =>
      `Mapapet के इंटरैक्टिव मानचित्र पर अपने आस-पास “${label}” से जुड़े विज्ञापन, सेवाएँ और संपर्क खोजें।`,
    blogDescription:
      "पालतू जानवरों, देखभाल, फार्म, पशु चिकित्सा और जिम्मेदार पशुपालन पर व्यावहारिक मार्गदर्शिकाएँ।",
    forumDescription:
      "जानवरों पर एक अंतरराष्ट्रीय मंच जहाँ लोग अनुभव साझा करते हैं, प्रश्न पूछते हैं और एक-दूसरे की मदद करते हैं।",
    forumSectionTitle: (label) => `${label} फ़ोरम | Mapapet`,
    notFoundTitle: "पृष्ठ नहीं मिला | Mapapet",
  },
  ko: {
    categoryDescription: (label) =>
      `Mapapet 대화형 지도에서 내 주변의 “${label}” 관련 광고, 서비스와 연락처를 찾아보세요.`,
    blogDescription:
      "반려동물, 돌봄, 농장, 수의 서비스와 책임 있는 동물 양육에 관한 실용적인 안내입니다.",
    forumDescription:
      "사람들이 경험을 공유하고 질문하며 서로 돕는 국제 동물 커뮤니티 포럼입니다.",
    forumSectionTitle: (label) => `${label} 포럼 | Mapapet`,
    notFoundTitle: "페이지를 찾을 수 없음 | Mapapet",
  },
  ja: {
    categoryDescription: (label) =>
      `Mapapetのインタラクティブ地図で、近くの「${label}」に関する広告、サービス、連絡先を探せます。`,
    blogDescription:
      "ペット、動物ケア、農場、獣医療、責任ある飼育についての実用的なガイドです。",
    forumDescription:
      "動物について経験を共有し、質問し、助け合う国際コミュニティフォーラムです。",
    forumSectionTitle: (label) => `${label}フォーラム | Mapapet`,
    notFoundTitle: "ページが見つかりません | Mapapet",
  },
  zh: {
    categoryDescription: (label) =>
      `在 Mapapet 互动地图上查找附近与“${label}”相关的广告、服务和联系方式。`,
    blogDescription:
      "关于宠物、动物护理、农场、兽医服务和负责任饲养的实用指南。",
    forumDescription:
      "一个国际动物社区论坛，人们在这里分享经验、提问并互相帮助。",
    forumSectionTitle: (label) => `${label}论坛 | Mapapet`,
    notFoundTitle: "找不到页面 | Mapapet",
  },
  ar: {
    categoryDescription: (label) =>
      `اعثر على الإعلانات والخدمات وبيانات التواصل المتعلقة بـ«${label}» بالقرب منك على خريطة Mapapet التفاعلية.`,
    blogDescription:
      "أدلة عملية عن الحيوانات الأليفة والرعاية والمزارع والخدمات البيطرية والتربية المسؤولة.",
    forumDescription:
      "منتدى دولي للحيوانات يشارك فيه الناس الخبرات ويطرحون الأسئلة ويساعد بعضهم بعضاً.",
    forumSectionTitle: (label) => `منتدى ${label} | Mapapet`,
    notFoundTitle: "الصفحة غير موجودة | Mapapet",
  },
};

const CATEGORY_PATHS = {
  "/dogs": "dogs",
  "/cats": "cats",
  "/birds": "birds",
  "/rodents": "rodents",
  "/reptiles": "reptiles",
  "/aquarium": "aquarium",
  "/insects": "insects",
  "/lostfound": "lostfound",
  "/mating": "mating",
  "/farm": "farm",
  "/farm/cows": "cows",
  "/farm/horses": "horses",
  "/farm/pigs": "pigs",
  "/farm/sheep": "sheep",
  "/farm/goats": "goats",
  "/farm/poultry": "poultry",
  "/farm/bees": "bees",
  "/farm/fur": "fur",
  "/farm/fishFarm": "fishFarm",
  "/farm/otherFarm": "otherFarm",
  "/zooBusiness": "zooBusiness",
  "/zooBusiness/shops": "shops",
  "/zooBusiness/pharmacy": "pharmacy",
  "/zooBusiness/clinics": "clinics",
  "/zooBusiness/grooming": "grooming",
  "/zooBusiness/onlineServices": "onlineServices",
  "/zooBusiness/transport": "transport",
  "/zooBusiness/walking": "walking",
  "/zooBusiness/boarding": "boarding",
  "/zooBusiness/training": "training",
  "/zooBusiness/photo": "photo",
  "/zooBusiness/kennels": "kennels",
  "/zooBusiness/nursery": "nursery",
  "/zooBusiness/shelters": "shelters",
};

const CANONICAL_ALIASES = {
  "/farm/fish": "/farm/fishFarm",
  "/zooBusiness/online": "/zooBusiness/onlineServices",
  "/zooBusiness/delivery": "/zooBusiness/transport",
  "/zooBusiness/walk": "/zooBusiness/walking",
};

const PRIVATE_ROUTE_PATTERN =
  /^\/(admin|messages|login|register|user-map|email-signin|email-signin-page)(\/|$)/i;

const INFO_ROUTE_KEYS = {
  "/about": "about",
  "/contacts": "contacts",
  "/help": "help",
  "/rules": "rules",
};

const normalizeLanguage = (language) =>
  SEO_LANGUAGES.includes(language) ? language : "en";

export const getSeoCopy = (language) =>
  SEO_COPY[normalizeLanguage(language)] || SEO_COPY.en;

export const normalizeSeoPath = (pathname = "/") => {
  const rawPath = String(pathname || "/").split("#")[0] || "/";
  const withoutTrailingSlash = rawPath.length > 1
    ? rawPath.replace(/\/+$/, "")
    : rawPath;

  return CANONICAL_ALIASES[withoutTrailingSlash] || withoutTrailingSlash;
};

export const getCanonicalPath = (pathname, search = "") => {
  const normalizedPath = normalizeSeoPath(pathname);

  if (normalizedPath === "/blog") {
    const params = new URLSearchParams(search || "");
    const page = Number(params.get("page"));
    if (Number.isInteger(page) && page > 1) {
      return `/blog?page=${page}`;
    }
  }

  return normalizedPath;
};

export const buildLocalizedUrl = (language, path = "/") => {
  const safeLanguage = normalizeLanguage(language);
  const domain = LANGUAGE_DOMAINS[safeLanguage] || LANGUAGE_DOMAINS.en;
  const safePath = String(path || "/").startsWith("/")
    ? String(path || "/")
    : `/${path}`;

  return `https://${domain}${safePath}`;
};

export const buildHreflangLinks = (path = "/") => [
  ...SEO_LANGUAGES.map((language) => ({
    language,
    href: buildLocalizedUrl(language, path),
  })),
  {
    language: "x-default",
    href: buildLocalizedUrl("en", path),
  },
];

export const ensureAbsoluteImageUrl = (image) => {
  const value = String(image || "").trim();
  if (!value) return DEFAULT_SEO_IMAGE;
  if (/^https?:\/\//i.test(value)) return value;
  if (value.startsWith("//")) return `https:${value}`;
  return `${SITE_ORIGIN}${value.startsWith("/") ? value : `/${value}`}`;
};

const translatedValue = (t, key, fallback) => {
  const value = t(key, { defaultValue: fallback });
  return value && value !== key ? value : fallback;
};

const makePageTitle = (label) => `${label} | ${SITE_NAME}`;

export const resolveStaticSeo = ({
  pathname,
  search,
  language,
  t,
}) => {
  const safeLanguage = normalizeLanguage(language);
  const copy = getSeoCopy(safeLanguage);
  const canonicalPath = getCanonicalPath(pathname, search);
  const normalizedPath = normalizeSeoPath(pathname);
  const defaultTitle = translatedValue(
    t,
    "seo.title",
    "Mapapet | International animal map"
  );
  const defaultDescription = translatedValue(
    t,
    "seo.description",
    "Find animals, services, farms, shelters and pet businesses near you on Mapapet."
  );

  if (PRIVATE_ROUTE_PATTERN.test(normalizedPath)) {
    return {
      title: SITE_NAME,
      description: defaultDescription,
      canonicalPath,
      robots: "noindex,nofollow,noarchive",
      schemaType: "WebPage",
      isPrivate: true,
    };
  }

  if (normalizedPath === "/") {
    return {
      title: defaultTitle,
      description: defaultDescription,
      canonicalPath,
      robots: "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1",
      schemaType: "WebSite",
    };
  }

  if (CATEGORY_PATHS[normalizedPath]) {
    const categoryKey = CATEGORY_PATHS[normalizedPath];
    const label = translatedValue(
      t,
      `categories.${categoryKey}`,
      categoryKey
    );

    return {
      title: makePageTitle(label),
      description: copy.categoryDescription(label),
      canonicalPath,
      robots: "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1",
      schemaType: "CollectionPage",
      breadcrumbLabel: label,
    };
  }

  if (normalizedPath === "/blog") {
    const label = translatedValue(t, "blog.title", "Blog");
    return {
      title: makePageTitle(label),
      description: copy.blogDescription,
      canonicalPath,
      robots: "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1",
      schemaType: "Blog",
      breadcrumbLabel: label,
    };
  }

  if (/^\/blog\/[^/]+$/i.test(normalizedPath)) {
    const label = translatedValue(t, "blog.title", "Blog");
    return {
      title: makePageTitle(label),
      description: copy.blogDescription,
      canonicalPath,
      robots: "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1",
      schemaType: "Article",
      breadcrumbLabel: label,
      dynamic: true,
    };
  }

  if (normalizedPath === "/forum") {
    const label = translatedValue(t, "forum.title", "Forum");
    const description = translatedValue(
      t,
      "forum.subtitle",
      copy.forumDescription
    );

    return {
      title: makePageTitle(label),
      description,
      canonicalPath,
      robots: "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1",
      schemaType: "CollectionPage",
      breadcrumbLabel: label,
    };
  }

  const forumSectionMatch = normalizedPath.match(/^\/forum\/section\/(\d+)$/i);
  if (forumSectionMatch) {
    const sectionId = forumSectionMatch[1];
    const label = translatedValue(
      t,
      `forum.sections.${sectionId}.title`,
      translatedValue(t, "forum.title", "Forum")
    );
    const description = translatedValue(
      t,
      `forum.sections.${sectionId}.description`,
      copy.forumDescription
    );

    return {
      title: copy.forumSectionTitle(label),
      description,
      canonicalPath,
      robots: "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1",
      schemaType: "CollectionPage",
      breadcrumbLabel: label,
    };
  }

  if (/^\/forum\/thread\/[^/]+$/i.test(normalizedPath)) {
    const label = translatedValue(t, "forum.title", "Forum");
    return {
      title: makePageTitle(label),
      description: copy.forumDescription,
      canonicalPath,
      robots: "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1",
      schemaType: "DiscussionForumPosting",
      breadcrumbLabel: label,
      dynamic: true,
    };
  }

  if (normalizedPath === "/donate") {
    return {
      title: translatedValue(t, "donatePage.metaTitle", `Donate | ${SITE_NAME}`),
      description: translatedValue(
        t,
        "donatePage.metaDescription",
        "Support Mapapet and the development of tools that help animals and people."
      ),
      canonicalPath,
      robots: "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1",
      schemaType: "WebPage",
      breadcrumbLabel: translatedValue(t, "categories.donate", "Donate"),
    };
  }

  if (INFO_ROUTE_KEYS[normalizedPath]) {
    const pageKey = INFO_ROUTE_KEYS[normalizedPath];
    return {
      title: translatedValue(
        t,
        `infoPages.${pageKey}.metaTitle`,
        `${translatedValue(t, `infoPages.${pageKey}.title`, pageKey)} | ${SITE_NAME}`
      ),
      description: translatedValue(
        t,
        `infoPages.${pageKey}.metaDescription`,
        defaultDescription
      ),
      canonicalPath,
      robots: "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1",
      schemaType: "WebPage",
      breadcrumbLabel: translatedValue(
        t,
        `infoPages.${pageKey}.title`,
        pageKey
      ),
    };
  }

  if (normalizedPath === "/privacy") {
    return {
      title: translatedValue(
        t,
        "privacyPolicy.metaTitle",
        `Privacy Policy | ${SITE_NAME}`
      ),
      description: translatedValue(
        t,
        "privacyPolicy.metaDescription",
        defaultDescription
      ),
      canonicalPath,
      robots: "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1",
      schemaType: "WebPage",
      breadcrumbLabel: translatedValue(t, "footer.privacy", "Privacy"),
    };
  }

  return {
    title: copy.notFoundTitle,
    description: defaultDescription,
    canonicalPath,
    robots: "noindex,follow",
    schemaType: "WebPage",
    notFound: true,
  };
};

export const buildStaticJsonLd = ({
  seo,
  language,
}) => {
  const safeLanguage = normalizeLanguage(language);
  const url = buildLocalizedUrl(safeLanguage, seo.canonicalPath || "/");
  const websiteId = `${SITE_ORIGIN}/#website`;
  const organizationId = `${SITE_ORIGIN}/#organization`;

  const graph = [
    {
      "@type": "Organization",
      "@id": organizationId,
      name: SITE_NAME,
      url: SITE_ORIGIN,
      logo: {
        "@type": "ImageObject",
        url: DEFAULT_SEO_IMAGE,
      },
    },
    {
      "@type": "WebSite",
      "@id": websiteId,
      name: SITE_NAME,
      url: SITE_ORIGIN,
      inLanguage: safeLanguage,
      publisher: { "@id": organizationId },
    },
  ];

  if (!seo.isPrivate && !seo.notFound) {
    graph.push({
      "@type": seo.schemaType || "WebPage",
      "@id": `${url}#webpage`,
      url,
      name: seo.title,
      description: seo.description,
      inLanguage: safeLanguage,
      isPartOf: { "@id": websiteId },
      primaryImageOfPage: {
        "@type": "ImageObject",
        url: DEFAULT_SEO_IMAGE,
      },
    });

    if (seo.canonicalPath !== "/" && seo.breadcrumbLabel) {
      graph.push({
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: SITE_NAME,
            item: buildLocalizedUrl(safeLanguage, "/"),
          },
          {
            "@type": "ListItem",
            position: 2,
            name: seo.breadcrumbLabel,
            item: url,
          },
        ],
      });
    }
  }

  return {
    "@context": "https://schema.org",
    "@graph": graph,
  };
};
